export enum DaysOfWeek {
  MONDAY = 'monday',
  TUESDAY = 'tuesday',
  WEDNESDAY = 'wednesday',
  THURSDAY = 'thursday',
  FRIDAY = 'friday',
  SATURDAY = 'saturday',
  SUNDAY = 'sunday'
}

export enum Events {
  SAVE_CLICKED = 'saveClicked'
}

export enum BlfTypes {
  NOT_USED = 'notUsed',
  BLF = 'blf',
  SPEED_DIAL = 'speedDial',
  LINE = 'line',
  BLF_NO_PICKUP = 'blfNoPickup',
  EXTENSION_MOBILITY = 'extensionMobility'
}

export interface Schedule {
  from: string
  to: string
}

export interface ScheduleItem {
  id: string
  isWorkingDay: boolean
  date: string
  schedule: Schedule[]
}

export interface PermanentSchedule {
  template?: string,
  items: ScheduleItem[]
}

export interface IPrioritable {
  priority: number
}
export interface ScenarioValue {
  [key: string]: string
}
export interface Scenarios {
  [key: string]: ScenarioValue
}

export interface VoiceMail {
    requestPinCode: boolean,
    pinCode: string,
    maxSize: number,
    maxDuration: number,
    overwriteMessages: boolean,
    notifyByEmail: boolean,
    email?: string,
    pinMessagesToNotification: boolean,
    callsAllowed: boolean,
    callsAllowedType: string,
    from: string,
    to: string,
    usePhoneNumberForNotifications: boolean,
    phoneNumber: string,
    totalMessagesLength: number
}

export type VoiceMailField = keyof VoiceMail

export enum CallsAllowedTypes {
  ALWAYS = 'always',
  SELECT_TIME = 'selectTime'
}

export type PriorityDirections = 'up' | 'down'

export interface AliasSub {
  guid: string,
  prefix: string,
  aliasGroup: string,
  alias: string
}
export enum FeaturesNames {
  DEFAULT = 'default',
  INSTANT_MESSAGING = 'InstantMessaging',
  CLIR = 'CLIR',
  HOLD = 'Hold',
  TRANSFER = 'Transfer',
  FORWARD = 'Forward',
  CONFERENCE = 'Conference',
  CALL_INTRUSION = 'CallIntrusion',
  CALL_WAITING = 'CallWaiting',
  MPTY_CONFERENCE = 'MptyConference',
  BLF = 'Blf',
  ALARM = 'Alarm',
  SPEED_DIAL = 'SpeedDial',
  CLIP = 'CLIP',
  WEB_CALL_BACKORDER = 'WebCallbackOrder',
  WEB_TO_FAX = 'WebToFax',
  DO_NOT_DISTURB = 'DoNotDisturb',
  BLACK_WHITE_LIST = 'BlackWhiteList',
  VOICE_MAILBOX_ACCESS = 'VoiceMailBoxAccess',
  VOICEMAIL_FORWARDING = 'VoiceMailForwarding',
  FOLLOW_ME = 'FollowMe',
  IVR = 'IVR',
  MULTI_TERMINAL = 'MultiTerminal',
  AUTO_DIAL = 'AutoDial',
  SAVE_PROMPT = 'SavePrompt',
  REDIAL = 'Redial',
  QUERY_SERVICE_LIST = 'QueryServiceList',
  QUERY_ALARM = 'QueryAlarm',
  QUERY_FWD = 'QueryFwd',
  QUERY_SPEED_DIAL = 'QuerySpeedDial',
  SUBSCRIBER_PICKUP = 'SubscriberPickUp',
  SUBSCRIBER_AUTO_DIAL_CALLBACK = 'SubscriberAutoDialCallBack',
  MISSED_CALL_NOTIFICATION = 'MissedCallNotification',
  FMC = 'FMC',
  ACCESS_GROUP_MANAGEMENT = 'AccessGroupManagement',
  AUDIO_FILES_MANAGEMENT = 'AudiofilesManagement',
  CALLBACK_ORDER = 'CallbackOrder',
  CHATROOM = 'ChatRoom',
  CALL_PARK = 'CallPark',
  VIRTUAL_FAX = 'VirtualFax',
  PERSONAL_WEB_CABINET_ACCESS = 'PersonalWebCabinetAccess',
  WEBCLIENT_FILES = 'WebClientFiles',
  SET_DND = 'SetDND',
  RTU_CLIENT = 'RTUClient',
  /** Услуга «Детализация вызовов» / «Доступ к CDR» (WUI-4375, RTU-12829). */
  CDRS_ACCESS = 'CDRsAccess',
}

export const SubscriberServices = {
  Forward: FeaturesNames.FORWARD,
  BlackWhiteList: FeaturesNames.BLACK_WHITE_LIST,
  DoNotDisturb: FeaturesNames.DO_NOT_DISTURB,
  VoiceMailForwarding: FeaturesNames.VOICEMAIL_FORWARDING,
  FollowMe: FeaturesNames.FOLLOW_ME,
  IVR: FeaturesNames.IVR,
} as const

export type SubscriberServices = typeof SubscriberServices[keyof typeof SubscriberServices]
export interface SubscriberService {
  [key: string]: SubscriberServices
}
export interface ServicesList {
  guid : string,
  id: string,
  name: FeaturesNames,
  isDefault: boolean,
  dstResult: string,
  isUserServices: boolean,
}

export interface PackageOfServices {
  guid : string,
  enabled: boolean,
  name: FeaturesNames,
  isDefault: boolean,
  licensingOption: string,
  price: number,
  title: string,
  description: string,
  groupNames: [ string ],
}
export interface PermissionGroup {
  guid: string,
  type: string,
  name: FeaturesNames,
  aclEnabled: boolean,
}
export interface PermissionGroupUpdateItem {
  guid: string,
  aclEnabled: boolean,
}

export interface PermissionAndService {
  aclEnabled: boolean,
  guid: string,
  name: string,
  type?: string,
  packages?: Set<string>,
  group?: string,
  dstResult?: string
  isInPackage?: boolean
}

export interface Blf {
  buttonNumber: number,
  type: BlfTypes,
  phoneNumber: string,
  id?: string, // Данное поле требуется только на клиенте, на сервер оно не отправляется.
  isChange?: boolean,
}
